import { checkoutAnalyticsVersionEnum } from "@redotech/redo-model/conversion/checkout-conversion-metrics/analytics";
import * as zExt from "@redotech/rpc/ext";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";

export const setSplitAnalyticsVersionOverride = {
  name: "setSplitAnalyticsVersionOverride" as const,
  input: z.object({
    splitId: zExt.objectId(),
    // null clears the override, reverting the split to automatic
    // (hasShopifyPlus + startDate) analytics-version resolution.
    analyticsVersionOverride: createEnum(
      checkoutAnalyticsVersionEnum,
    ).nullable(),
  }),
  output: z.null(),
};
